export const environment = {
  production: false,
  apiUrl: "https://skillbridgeapi-development.up.railway.app",
  docsUrl: "https://skillbridge-docs.pages.dev",
  sentryDsn: ""
  // Add other development environment variables here
};
